import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { getUsers, setUsersFilter, clearUsersFilter, getUser } from '../../actions/users'
import { defaultUsersFilter } from '../../reducers/users'
import { Toolbar, ToolbarItem } from '../common/toolbar/toolbar'
import BusinessFilter from '../transaction_grid/business_filter'
import { fetchAllBusinesses } from '../../actions/businesses_all'
import BusinessFilterRedux from '../transaction_grid/business_filter_redux'

const groups = [
  { value: '', label: 'All groups' },
  { value: 'managers', label: 'Managers' },
  {
    value: 'end_users',
    label: 'End users',
  },
  {
    value: 'client_admins',
    label: 'Client admins',
  },
  {
    value: 'app_users',
    label: 'App users',
  },
  {
    value: 'post_only',
    label: 'Post only',
  },
  {
    value: 'clerks',
    label: 'Clerks',
  },
  {
    value: 'netki_staff',
    label: 'Netki staff',
  },
]
const statuses = {
  All: null,
  Active: true,
  Inactive: false,
}
const UserSearchBar = ({ filter, setUsersFilter, getUsers, clearUsersFilter, fetchAllBusinesses, getUser, user }) => {
  const handleEnterKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch(e)
    }
  }
  const onSearch = (e) => {
    e.preventDefault()
    setUsersFilter(filter)
    getUsers(filter)
  }

  const onReset = (e) => {
    e.preventDefault()
    clearUsersFilter()
    setData(defaultUsersFilter)
  }
  const handleChange = (e) => setUsersFilter({ ...filter, [e.target.name]: e.target.value })

  const setData = (filter) => {
    setUsersFilter(filter)
    getUsers(filter)
  }
  useEffect(() => {
    getUser()
  }, [])
  return (
    <Toolbar columns={user && user.is_staff ? 4 : 3}>
      <ToolbarItem className={'input-group'}>
        <input
          onKeyPress={handleEnterKeyPress}
          className='form-control'
          placeholder='Search'
          value={filter.name}
          name={'name'}
          onChange={handleChange}
        />
        <button className='btn btn-default' type='button' onClick={onSearch}>
          Search
        </button>
        <button className='btn btn-default' type='button' onClick={onReset}>
          Reset
        </button>
      </ToolbarItem>
      <ToolbarItem className={'input-group'}>
        <select
          value={filter.is_active}
          className='form-control'
          onChange={({ target }) => setData({ ...filter, is_active: target.value })}
        >
          {Object.entries(statuses).map(([status, value], i) => (
            <option key={i} value={value}>
              {status}
            </option>
          ))}
        </select>
      </ToolbarItem>
      {user && user.is_staff && (
        <ToolbarItem className={'input-group'}>
          <BusinessFilterRedux
            filterInvester={true}
            updateBusinessFilter={(businessId) => setData({ ...filter, business_id: businessId })}
            filter={filter.business_id}
          />
        </ToolbarItem>
      )}

      <ToolbarItem className={'input-group'}>
        <select
          value={filter.groups}
          className='form-control'
          onChange={({ target }) => setData({ ...filter, groups: target.value })}
        >
          {groups.map(({ value, label }, index) => (
            <option key={index} value={value}>
              {label}
            </option>
          ))}
        </select>
      </ToolbarItem>
      <ToolbarItem className={'input-group'} style={{ flex: 1, paddingRight: 5 }} last={true} />
    </Toolbar>
  )
}

const mapStateToProps = (state, ownProps) => ({
  filter: state.usersFilter.filter,
  user: state.getUser.user,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      setUsersFilter,
      clearUsersFilter,
      getUsers,
      fetchAllBusinesses,
      getUser,
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserSearchBar))
